import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CookieModule } from "ngx-cookie";
import { AccountJwtService } from "./+state/services";

@NgModule({
  imports: [CommonModule, CookieModule.forRoot()],
  providers: [AccountJwtService]
})
export class AccountJwtDataAccessModule {}
